import React, { useCallback } from "react";
import Icon from "@fortawesome/react-fontawesome";
import Card from "../components/Card";
import MyShoppingCartPurchasedProducts from "./MyShoppingCartPurchasedProducts";
import { Alert } from "reactstrap";
import { connect } from "react-redux";
import { getFailureSubmitShoppingCart } from "../modules/shoppingCart";
import { formatMoney } from "accounting";
import _ from "lodash/fp";
import WithFetchShoppingCart from "./WithFetchShoppingCart";
import Loading from "../components/Loading";
import TryAgain from "../components/TryAgain";
import { Link } from "react-router-dom";
import ShoppingCartCheckoutButton from "../components/ShoppingCartCheckoutButton";

const FailMessage = connect(state => ({
  failure: getFailureSubmitShoppingCart(state)
}))(({ failure }) => {
  if (failure) {
    return (
      <div className="my-2">
        <Alert color="danger">{failure}</Alert>
      </div>
    );
  }
  return null;
});

const CartTotal = ({ shoppingCart }) => {
  if (shoppingCart) {
    return (
      <div className="container-fluid">
        <div className="row total justify-content-end">
          <div className="col-auto">
            <h4>
              Total: <b>{formatMoney(shoppingCart.total_cost)}</b>
            </h4>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

const ShoppingCart = WithFetchShoppingCart(
  ({
    dealerId,
    customerId,
    fetchShoppingCart,
    failure,
    loading,
    shoppingCart
  }) => {
    const onTryAgain = useCallback(() => {
      fetchShoppingCart({ dealerId, customerId });
    }, [dealerId, customerId, fetchShoppingCart]);
    if (loading) {
      return <Loading label="Loading shopping cart" />;
    }
    if (failure) {
      return <TryAgain label={failure} onTryAgain={onTryAgain} />;
    }
    if (shoppingCart) {
      if (
        _.isEmpty(shoppingCart.purchased_products) &&
        _.isEmpty(shoppingCart.contracts)
      ) {
        return (
          <div>
            <h4>Shopping cart is empty</h4>
            <Link to="/products">
              Go to shopping <Icon icon="cart-plus" />
            </Link>
          </div>
        );
      }
      return (
        <div className="row shopping-cart">
          <div className="col">
            <h4>Products:</h4>
            <MyShoppingCartPurchasedProducts shoppingCart={shoppingCart} />
            <CartTotal shoppingCart={shoppingCart} />
            <FailMessage />
            <ShoppingCartCheckoutButton />
          </div>
        </div>
      );
    }
    return null;
  }
);

const MyShoppingCart = () => {
  return (
    <div className="row">
      <div className="col">
        <Card
          title={
            <h3 className="title">
              My Shopping Cart <Icon icon="shopping-cart" />
            </h3>
          }
          content={<ShoppingCart />}
        />
      </div>
    </div>
  );
};

export default MyShoppingCart;
